// reusable variables
export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'd016d5b8-2d95-4eac-876e-6bea2c1ac72c'
export const MODAL_CLOSE_SEC = 2.5;